import { axios } from './common';
import { CM_BASE_URL } from '../../pages/constants/cmConstants';
import { TM_CONSTANTS } from '../../pages/constants/tmConstants';

// Phase-2: endpoint pending Megh BE (FIN-11377/78) — contract = customer_framl_history v3
// FIN-14008 — the BE answers 403 for a customer none of whose alerts the user may see; the
// detail page shows this text instead of the customer.
export const FRAML_CUSTOMER_NOT_AUTHORIZED =
  'You are not authorized to view this customer.';

export const fetchAggregate = async (customerKey) => {
  const url = `${CM_BASE_URL}/framl/customers/${customerKey}/aggregate`;
  const res = await axios.get(url);
  if (res.status === 403) {
    throw new Error(FRAML_CUSTOMER_NOT_AUTHORIZED);
  }
  if (res.status !== 200) {
    throw new Error('Failed to fetch FRAML customer aggregate');
  }
  return res.data;
};

// Phase-2: endpoint pending Megh BE (FIN-11377/78) — contract = customer_framl_history v3
export const fetchScoreHistory = async (customerKey) => {
  const url = `${CM_BASE_URL}/framl/customers/${customerKey}/scoreHistory`;
  const res = await axios.get(url);
  if (res.status !== 200) {
    throw new Error('Failed to fetch FRAML customer score history');
  }
  return res.data;
};

// Phase-2: endpoint pending Megh BE (FIN-11377/78) — contract = customer_framl_history v3
export const fetchAlerts = async (customerKey) => {
  const url = `${CM_BASE_URL}/framl/customers/${customerKey}/alerts`;
  const res = await axios.get(url);
  if (res.status !== 200) {
    throw new Error('Failed to fetch FRAML customer alerts');
  }
  return res.data;
};

// Phase-2: endpoint pending Megh BE (FIN-11377/78) — contract = customer_framl_history v3
export const fetchRiskFactors = async (customerKey) => {
  const url = `${CM_BASE_URL}/framl/customers/${customerKey}/riskFactors`;
  const res = await axios.get(url);
  if (res.status !== 200) {
    throw new Error('Failed to fetch FRAML customer risk factors');
  }
  return res.data;
};

// FIN-11398 — Customer Details tab (party identity). Unlike the aggregate/score/
// alerts/riskFactors endpoints (CM `/framl/customers/*`, Megh's DDL), this reads the
// TM-common customers controller, mounted at `/tm/common/customers` on the AMLS BE
// (`GET {AMLS}/tm/common/customers/:key/framlCustomerDetails`,
// FramlCustomerController→getCustomerDetails→AlertedCustomerTable). Returns an array of
// AlertedCustomer party-identity rows.
export const fetchCustomerDetails = async (customerKey) => {
  const url = `${TM_CONSTANTS.TM_BASE_URL}/tm/common/customers/${customerKey}/framlCustomerDetails`;
  const res = await axios.get(url);
  if (res.status !== 200) {
    throw new Error('Failed to fetch FRAML customer details');
  }
  return res.data;
};

// FIN-11398 — Customer Details tab sub-tables. Customer-scoped (no alertId):
// BE resolves the customer's alertIds and unions the alert-scoped sources.
// TM `/tm/common/customers/:key/...` (same controller as framlCustomerDetails).
export const fetchAssociatedCustomers = async (customerKey) => {
  const url = `${TM_CONSTANTS.TM_BASE_URL}/tm/common/customers/${customerKey}/associatedCustomers`;
  const res = await axios.get(url);
  if (res.status !== 200) {
    throw new Error('Failed to fetch associated customers');
  }
  return res.data;
};

export const fetchAssociatedAccounts = async (customerKey) => {
  const url = `${TM_CONSTANTS.TM_BASE_URL}/tm/common/customers/${customerKey}/associatedAccounts`;
  const res = await axios.get(url);
  if (res.status !== 200) {
    throw new Error('Failed to fetch associated accounts');
  }
  return res.data;
};

// FIN-12966 — server-paged. The BE scopes to the customer's latest
// alert and returns { customers, totalCount, isTruncated }. `paging`
// is optional, so an un-paged caller still works.
export const fetchSimilarKyc = async (customerKey, paging = {}) => {
  const base = `${TM_CONSTANTS.TM_BASE_URL}/tm/common/customers/${customerKey}/similarKycByCustomer`;
  const qs = [];
  if (typeof paging.limit === 'number') qs.push(`limit=${paging.limit}`);
  if (typeof paging.offset === 'number') qs.push(`offset=${paging.offset}`);
  const url = qs.length ? `${base}?${qs.join('&')}` : base;
  const res = await axios.get(url);
  if (res.status !== 200) {
    throw new Error('Failed to fetch similar KYC customers');
  }
  return res.data;
};
